import { inject, Injectable } from '@angular/core';
import { HttpGatewayService } from '../../../core/services/http-gateway.service';
import { Observable } from 'rxjs';
import {
    ActiveBroadcast,
    BroadcastDetails,
    BroadcastListItem,
    BroadcastRequestBody,
    BroadcastStatus,
} from '../types/broadcast';
import { UrlBuilder } from '../../../shared/utils/url-utils';

const BROADCAST_URLS = {
    BROADCASTS: 'api/v5/admin/broadcasts',
    BROADCAST_BY_ID: 'api/v5/admin/broadcasts/{broadcastId}',
    BROADCASTS_ACTIVE: 'api/v5/broadcasts/active',
};

@Injectable({ providedIn: 'root' })
export class BroadcastService {
    private http = inject(HttpGatewayService);

    public getAllBroadcasts(): Observable<BroadcastListItem[]> {
        return this.http.get(BROADCAST_URLS.BROADCASTS);
    }

    public createBroadcast(
        status?: BroadcastStatus,
        v3?: boolean,
        v5?: boolean,
        startDate?: number,
        endDate?: number,
        title?: string,
        html?: string,
        image?: string | null,
        buttonLabel?: string,
        buttonUrl?: string,
    ): Observable<BroadcastDetails> {
        const request: BroadcastRequestBody = {
            status,
            v3,
            v5,
            startDate,
            endDate,
            title,
            html,
            image,
            buttonLabel,
            buttonUrl,
        };

        return this.http.post(BROADCAST_URLS.BROADCASTS, request);
    }

    public updateBroadcast(
        id: string,
        status?: BroadcastStatus,
        v3?: boolean,
        v5?: boolean,
        startDate?: number,
        endDate?: number,
        title?: string,
        html?: string,
        image?: string | null,
        buttonLabel?: string,
        buttonUrl?: string,
    ): Observable<BroadcastDetails> {
        const url = new UrlBuilder(BROADCAST_URLS.BROADCAST_BY_ID).addBroadcastId(id).toUrl();
        const request: BroadcastRequestBody = {
            status,
            v3,
            v5,
            startDate,
            endDate,
            title,
            html,
            image,
            buttonLabel,
            buttonUrl,
        };

        return this.http.put(url, request);
    }

    public getBroadcastDetails(id: string): Observable<BroadcastDetails> {
        const url = new UrlBuilder(BROADCAST_URLS.BROADCAST_BY_ID).addBroadcastId(id).toUrl();

        return this.http.get(url);
    }

    public deleteBroadcast(id: string): Observable<{ id: string }> {
        const url = new UrlBuilder(BROADCAST_URLS.BROADCAST_BY_ID).addBroadcastId(id).toUrl();

        return this.http.delete(url);
    }

    public getActiveBroadcasts(): Observable<ActiveBroadcast[]> {
        return this.http.get(BROADCAST_URLS.BROADCASTS_ACTIVE);
    }
}
